import PropTypes from 'prop-types';
import classnames from 'classnames';
import { USER_INTERFACE_ARROW_04_RIGHT, Icon, Button } from '@bwoty-web/styleguide';
import './cruiseListCardFooter.scss';

const CruiseListCardFooter = ({
  footerContent: {
    texts: {
      buttonText,
      packageInfoText,
      durAndDepText,
      noPriceText,
      priceInfoText,
    },
    prices: {
      price,
      originalPrice,
      isDiscounted,
      pricePerPerson,
      perPersonText,
    },
  },
  href,
  onSelect,
  buttonHref,
}) => {
  const hasPrice = !!price;

  const currentPriceClassNames = classnames(
    'iw-cruise-list-card-footer__current-price', {
    'iw-cruise-list-card-footer__current-price--discount': isDiscounted,
  });

  const content = hasPrice ? (
    <>
      <div className="iw-cruise-list-card-footer__info-section">
        <div className="iw-cruise-list-card-footer__info-label">{packageInfoText}</div>
        <div className="iw-cruise-list-card-footer__info-label">{durAndDepText}</div>
      </div>
      <div className="iw-cruise-list-card-footer__price-section">
        <div>
        <div className="iw-cruise-list-card-footer__price-info-text">
            {priceInfoText || null}
          </div>
          {isDiscounted ? (
            <div className="iw-cruise-list-card-footer__original-price">
              {originalPrice}
            </div>
          ) : null}
          <div className={currentPriceClassNames}>{price}</div>
          {pricePerPerson && (
            <div className="iw-cruise-list-card-footer__price-per-person">
              <span>{pricePerPerson}</span>
              <span>{perPersonText}</span>
            </div>
          )}
        </div>
      </div>
      <Icon path={USER_INTERFACE_ARROW_04_RIGHT} size="xs" className="iw-cruise-list-card-footer__icon" />
    </>
  ) : (
    <div className="iw-cruise-list-card-footer__price-section iw-cruise-list-card-footer__no-price-section">
      {noPriceText}
    </div>
  );

  return (
    <div className="iw-cruise-list-card-footer-container">
      <div className="iw-cruise-list-card-footer__content">
        {content}
      </div>
      <div className="iw-cruise-list-card-footer__cta-container">
        {((buttonHref || href || onSelect) && buttonText) ? (
          <Button
            theme="primary"
            onClick={onSelect}
            href={buttonHref || href}
            rel="nofollow"
            className="iw-cruise-list-card-footer__primary-button"
          >
            {buttonText}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

CruiseListCardFooter.propTypes = {
  footerContent: PropTypes.shape({
    texts: PropTypes.shape({
      buttonText: PropTypes.string,
      packageInfoText: PropTypes.string,
      durAndDepText: PropTypes.string,
      noPriceText: PropTypes.string,
      priceInfoText: PropTypes.string,
    }),
    prices: PropTypes.shape({
      price: PropTypes.string,
      originalPrice: PropTypes.string,
      isDiscounted: PropTypes.bool,
      pricePerPerson: PropTypes.string,
      perPersonText: PropTypes.string,
    }),
  }),
  href: PropTypes.string,
  onSelect: PropTypes.func,
  buttonHref: PropTypes.string,
};

CruiseListCardFooter.defaultProps = {
  footerContent: null,
  href: null,
  onSelect: null,
  buttonHref: null,
};

export default CruiseListCardFooter;
